import create from 'zustand';
import { immer } from 'zustand/middleware/immer'
import {SortParams} from "@/components/SortIndicator";
import { SortPostParams } from "@/containers/admin/layers/Layers"

export const LayersListHeader = [
  {
    headerName:'レイヤー名',
    sortItemName: 'name',
  },
  {
    headerName:'レイヤーURL',
    sortItemName: 'url',
  },
];

const initState = {
  queryParams: undefined,
  childSubmit: () => {
  },
  sortParams: {} as SortParams,
  doSort: () => {
  },
}

type LayersStore = {
  queryParams: SortPostParams | undefined;
  setQueryParams: (any: SortPostParams | undefined) => void;
  sortParams: SortParams;
  setSortParams: (sortParams: SortParams) => void;
  doSort: (sortParams: SortParams) => void;
  setDoSort: (func: LayersStore['doSort']) => void;

};

export const useLayersStore = create<LayersStore>()(
  immer((set) => ({
    ...initState,
    setQueryParams: (queryParams) =>
      set((state) => ({
        queryParams: queryParams,
      })),
    setSortParams: (sortParams) =>
      set((state) => ({
        sortParams: sortParams,
      })),
    setDoSort: (doSort) =>
      set((state) => ({
        doSort: doSort,
      }))
  }))
);
